import React, { Component } from 'react'
import { withRouter } from 'react-router'
import PageRegion from './PageRegionDep'
import { Query } from 'react-apollo'
import gql from 'graphql-tag'
import routes from 'src/routing/routes'
import { getUrlValueFromValue, getValueFromUrlValue } from 'src/utils'
import ErrorPage from '../../../ErrorPage'

const gqlQuery = gql`
  query TerritoryInfos(
    $inseeCode: String!
    $isRegion: Boolean!
    $category: String
  ) {
    territoryInfos(
      inseeCode: $inseeCode
      isRegion: $isRegion
      category: $category
    ) {
      cities {
        id
        name
      }
      region {
        id
        name
        inseeCode
        squareBounds
      }
      department {
        id
        name
        inseeCode
        squareBounds
        regionName
        regionInseeCode
      }
      searchResult {
        nbRes
        producers {
          id
          companyName
          presentation
          photoProducerUrl
          categories
          addressCity
          addressPostalCode
          addressCoordinates
        }
      }
    }
  }
`

export const PRODUCER_PER_PAGE = 50

class PageRegionDepContainer extends Component {
  constructor(props) {
    super(props)
    this.state = {
      page:
        this.props.match.params.page && this.props.match.params.page > 0
          ? this.props.match.params.page
          : '1',
      codeRegion: this.props.match.params.inseeRegion,
      codeDepartment: this.props.match.params.inseeDepartment,
      isRegion: !!this.props.match.params.inseeRegion,
      category: getValueFromUrlValue(this.props.match.params.category)
    }
  }

  componentDidUpdate() {
    const {
      page,
      category,
      inseeRegion,
      inseeDepartment
    } = this.props.match.params
    const cat = getValueFromUrlValue(category)

    if (page !== this.state.page) {
      const catUrl = getUrlValueFromValue(this.state.category)

      if (!page || page < 1) {
        this.props.history.replace(
          this.state.isRegion
            ? routes.mapRegion
                .replace(':category', catUrl)
                .replace(':inseeRegion', this.state.codeRegion)
                .replace(':page', '1')
            : routes.mapDepartment
                .replace(':category', catUrl)
                .replace(':inseeDepartment', this.state.codeDepartment)
                .replace(':page', '1')
        )
        this.setState({ page: '1' })
      } else {
        this.props.history.replace(
          this.state.isRegion
            ? routes.mapRegion
                .replace(':category', catUrl)
                .replace(':inseeRegion', this.state.codeRegion)
                .replace(':page', page.toString())
            : routes.mapDepartment
                .replace(':category', catUrl)
                .replace(':inseeDepartment', this.state.codeDepartment)
                .replace(':page', page.toString())
        )
        this.setState({ page: page.toString() })
      }
    }

    if (cat !== this.state.category) {
      this.setState({ category: cat })
    }

    if (
      inseeRegion !== this.state.codeRegion ||
      inseeDepartment !== this.state.codeDepartment
    ) {
      this.setState({
        isRegion: !!this.props.match.params.inseeRegion,
        codeDepartment: inseeDepartment,
        codeRegion: inseeRegion
      })
    }
  }

  render() {
    return (
      <Query
        query={gqlQuery}
        variables={{
          inseeCode: this.state.isRegion
            ? this.state.codeRegion
            : this.state.codeDepartment,
          isRegion: this.state.isRegion,
          category: this.state.category
        }}
      >
        {({ loading, error, data }) => {
          const nbPages =
            data && data.territoryInfos
              ? Math.ceil(
                  data.territoryInfos.searchResult.nbRes / PRODUCER_PER_PAGE
                )
              : 0

          return error ||
            (!loading &&
              nbPages !== 0 &&
              parseInt(this.state.page) > nbPages) ? (
            <ErrorPage />
          ) : (
            <PageRegion
              page={this.state.page}
              bounds={
                loading
                  ? null
                  : this.state.isRegion
                  ? data.territoryInfos.region.squareBounds
                  : data.territoryInfos.department.squareBounds
              }
              loading={loading}
              isRegion={this.state.isRegion}
              region={
                !loading && this.state.isRegion
                  ? data.territoryInfos.region
                  : null
              }
              cities={!loading ? data.territoryInfos.cities : null}
              department={
                !loading && !this.state.isRegion
                  ? data.territoryInfos.department
                  : null
              }
              category={this.state.category}
              data={
                !loading && data.territoryInfos
                  ? data.territoryInfos.searchResult
                  : null
              }
            />
          )
        }}
      </Query>
    )
  }
}

export default withRouter(PageRegionDepContainer)
